module.exports = __webpack_public_path__ + "static/media/step-two-code.70427984.png";